export * from './bulk-message-modal.component';
export * from './bulk-message-modal.module';
